import React from 'react'
import './About.css'

const About = () => {
  return (
 <div id='about'>
  <div className="about-content">
  <p>
    Hi! I’m Obinna, a trained Computer Engineer and Full-Stack Developer
    with a strong focus on building scalable, production-ready web applications.
    I have over 3 years of experience working with modern web technologies,
    and I specialize in designing systems that connect robust frontend interfaces
    with efficient backend services.
  </p>

  <p>
    My technical stack includes TypeScript, JavaScript, React, and Next.js,
    along with UI libraries such as Material UI and state management tools like
    Redux Toolkit (RTK). On the backend, I build and maintain RESTful APIs using
    Node.js and Express, including authentication systems, business logic layers,
    and system integrations. I work with both PostgreSQL and MongoDB for data
    modeling, storage, and optimization depending on application requirements.
    I also have experience integrating Content Management Systems (CMS) and
    delivering full-stack applications end-to-end.
  </p>
</div>
  </div>
  )
} 

export default About  